/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_GpsInputs */

const fr_help_position_gps = /** @type {(inputs: Help_Position_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPS`)
};

const en_help_position_gps = /** @type {(inputs: Help_Position_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPS`)
};

/**
* | output |
* | --- |
* | "GPS" |
*
* @param {Help_Position_GpsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_gps = /** @type {((inputs?: Help_Position_GpsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_GpsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_gps(inputs)
	return en_help_position_gps(inputs)
});